import React from 'react'
import QuizCard from './QuizCard'
import classNames from 'classnames'

const QuizAnswer = ({card, questionType, selected, select, deselect, animating, animationData}) => {
  
  const handleClick = () => {
    if (selected) {
      deselect()
    } else {
      select()
    }
  }
  
  return (
    <div onClick={handleClick} className={classNames('answer-wrapper', {selected, animating})} >
      <QuizCard animating={animating} selected={selected} cardData={card} questionType={questionType} animationData={animationData}/>
    </div>
  )
}

export default QuizAnswer